var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restart-btn-relative",class:[_vm.button ? 'restart-btn--btn' : '']},[_c('div',{staticClass:"back-btn-wrapper"},[_c('button',{staticClass:"back-btn-wrapper-button",on:{"click":_vm.restart}},[_vm._v(" Relancer ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }